<template>
    <div class="col-md-12 card text-left">
      <div class="card-header"></div>
      <div class="report-filters">
        <div class="col-md-2 col-sm-6 col-xs-12 form-group pull-left">
          <input type="text" :placeholder="$t('reports.searchFilter')" class="form-control" v-model="clients.search">
        </div>
        <div class="col-md-2 col-sm-6 col-xs-12 form-group pull-left">
          <input type="number" :placeholder="$t('reports.minOrders')" class="form-control" v-model="clients.minOrder">
        </div>
        <div class="col-md-2 col-sm-6 col-xs-12 form-group pull-left">
          <input type="number" :placeholder="$t('reports.maxOrders')" class="form-control" v-model="clients.maxOrder">
        </div>
        <div class="col-md-2 col-sm-6 col-xs-12 form-group pull-left">
          <input type="number" :placeholder="$t('reports.minAmount')" class="form-control" v-model="clients.minAmount">
        </div>
        <div class="col-md-2 col-sm-6 col-xs-12 form-group pull-left date-range">
          <el-date-picker
            type="daterange"
            v-model="clients.valid"
            class="mid"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            :name="pickerNames"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </div>
        <div class="search-button-reports col-md-2 col-sm-6 col-xs-12 form-group pull-left">
          <div :title="$t('reports.search')" class="btn btn-icon btn-info" @click="getClients(null)"><i class="ti-search"></i></div>
        </div>
          <download-excel
            v-show="clientsTableData.length"
            class   = "btn btn-icon mar-rt-40 btn-success"
            :fetch   = "clientsExportData"
            :fields = "jsonFields"
            :name    = "export_name"
            :before-generate = "startDownload"
            :before-finish   = "finishDownload">
            <i class="ti-file"></i>
          </download-excel>
      </div>
      <div class="card-content total-pagination">
        <data-tables-server
          class=""
          @query-change="paginationChanged"
          v-loading="loading"
          :data="clientsTableData"
          :search-def="{ show: false }"
          :total="totalClients"
          :pagination-props="paginationProps"
          :table-props="tableOptions"
          @row-click="goToRecordCustomer"
          style="width: 100%;"
        >
          <el-table-column :min-width="80" sortable="custom" prop="name" :label="$t('reports.name')">
            <template slot-scope="props">
              {{ props.row.firstname }} {{ props.row.lastname }}
            </template>
          </el-table-column>
          <el-table-column
            :min-width="120"
            sortable="custom"
            prop="email"
            :label="$t('reports.email')"
          ></el-table-column>
          <el-table-column
            :min-width="60"
            sortable="custom"
            prop="created_at"
            label="Client from"
          ></el-table-column>
          <template slot-scope="props">
              <b>{{ props.row.created_at }}</b>
            </template>
          <el-table-column
            :min-width="60"
            sortable="custom"
            prop="orders_count"
            :label="$t('reports.ordersNumber')"
          >
            <template slot-scope="props">
              <b>{{ props.row.orders_count }}</b>
            </template>
          </el-table-column>
          <el-table-column
            :min-width="80"
            prop="label"
            label="Total valoare consumata"
          >
            <template slot-scope="props">
                <b>{{ props.row.totals_discount_loyalty_points }}</b>
            </template>
          </el-table-column>
          <el-table-column
            :min-width="80"
            prop="label"
            label="Total puncte acumulate"
          >
            <template slot-scope="props">
                <b>{{ props.row.gained_loyalty_points }}</b>
            </template>
          </el-table-column>
          <el-table-column
            :min-width="80"
            prop="label"
            label="Total puncte folosite"
          >
            <template slot-scope="props">
                <b>{{ props.row.used_loyalty_points }}</b>
            </template>
          </el-table-column>
          
          <el-table-column
            :min-width="80"
            prop="label"
            label="Total puncte disponibile"
          >
            <template slot-scope="props">
                <b>{{ props.row.loyalty_points }}</b>
            </template>
          </el-table-column>
        </data-tables-server>
      </div>
    </div>
  </template>
  <script>
  import Vue from 'vue'
  import moment from 'moment'
  import {DatePicker} from 'element-ui'
  import ChartCard from 'src/components/UIComponents/Cards/ChartCard.vue'
  import ChartBarsCard from 'src/components/UIComponents/Cards/ChartBarsCard.vue'
  import ChartPieCard from 'src/components/UIComponents/Cards/ChartPieCard.vue'
  import JsonExcel from 'vue-json-excel'
  Vue.component('downloadExcel', JsonExcel)
  export default {
    components: {
      [DatePicker.name]: DatePicker,
      ChartCard,
      ChartBarsCard,
      ChartPieCard
    },
    props: {
      isClients: {
        type: Boolean,
        default: false
      }
    },
    watch: {
      isClients () {
        if (this.isClients) {
          let firstQuery = {
            sort: {
              prop: 'name',
              order: 'asc'
            },
            page: 1,
            pageSize: 20
          }
          this.getClients(firstQuery)
        }
      }
    },
    data () {
      return {
        loading: false,
        donation_points_enabled: false,
        jsonFields: {
          [this.$t('reports.name')]: 'firstname',
          [this.$t('reports.email')]: 'email',
          [this.$t('reports.created_at')]: 'created_at',
          [this.$t('reports.gender')]: 'gender',
          [this.$t('reports.age')]: 'age',
          [this.$t('reports.donation_points')]: 'donation_points',
          [this.$t('reports.totalAmount')]: 'sales',
          [this.$t('reports.ordersNumber')]: 'orders_count'
        },
        export_name: 'Export Clienti - ',
        clients: {
          'valid': [
            moment().date(1).format('YYYY-MM-DD'),
            moment().endOf('month').format('YYYY-MM-DD')
          ],
          minOrder: null,
          maxOrder: null,
          minAmount: null,
          search: null
        },
        paginationProps: {
          // pageSizes: [5, 10, 15],
          layout: 'prev, pager, next, sizes, total'
        },
        tableOptions: {
          defaultSort: {
            prop: 'name',
            order: 'ascending'
          }
        },
        labels: null,
        labelingPrimaryOption: null,
        totalClients: null,
        sortBy: 'name',
        sortOrder: 'asc',
        clientsTableData: [],
        pickerOptions: {
          disabledDate (date) {
            return date < moment().subtract(6, 'months')
          }
        },
        pickerNames: ['date_from', 'date_to']
      }
    },
    methods: {
      async clientsExportData () {
        let resp = []
        if (this.clients) {
          let data = {
            token: this.$session.get('token'),
            company_id: this.$session.get('selectedCompany'),
            start_date: this.clients.valid[0],
            end_date: this.clients.valid[1],
            min_orders: this.clients.minOrder,
            max_orders: this.clients.maxOrder,
            min_ammount: this.clients.minAmount,
            filter: this.clients.search
          }
  
          let $dd = {}
          const sortOptions = {
            field: this.sortBy,
            order: this.sortOrder
          }
          data = {
            ...data,
            ...sortOptions
          }
  
  
          let ced = []
          let clientsData = []
          resp = await new Promise((resolve, reject) => {
            this.apiRequest('/reports/clients?page=' + 1 + '&pageSize=' + 50000, 'GET', data, response => {
              clientsData = response.data.clients.data
              if (clientsData) {
                for (const customer of clientsData) {
                  $dd = {
                    'firstname': customer.firstname,
                    'email': customer.email,
                    'created_at': customer.created_at,
                    'gender': customer.gender,
                    'birthdate': customer.birthdate,
                    'age': customer.age,
                    'orders_count': customer.orders_count,
                    'sales': this.formatMoneyAmount(customer.sales, '')
                  }
                  if (customer.donation_points) {
                    $dd['donation_points'] = customer.donation_points
                  }
                  ced.push($dd)
                }
              }
              resolve(ced)
            })
          })
          return resp
        }
      },
      startDownload () {
        this.loading = true
      },
      finishDownload () {
        this.loading = false
      },
      paginationChanged (query) {
        if (query.type === 'page') this.getClients(query)
        if (query.type === 'size') this.getClients(query)
        if (query.type === 'sort') {
          if (query.sort.order) {
            this.sortBy = query.sort.prop
            this.sortOrder = query.sort.order === 'descending' ? 'desc' : 'asc'
          } else {
            this.sortBy = 'name'
            this.sortOrder = 'asc'
          }
          this.getClients(query)
        }
      },
      getClients (query) {
        this.export_name = this.export_name + this.clients.valid[0] + ' - ' + this.clients.valid[1]
        let data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          filter: this.clients.search,
          start_date: this.clients.valid[0],
          end_date: this.clients.valid[1],
          min_orders: this.clients.minOrder,
          max_orders: this.clients.maxOrder
        }
  
        let sortColumn = ''
        let sortType = ''
        // let $dd = {}
        if (query) {
          sortColumn = query.sort.prop
          sortType = query.sort.order === 'descending' ? 'desc' : 'asc'
        } else {
          sortColumn = this.sortBy
          sortType = this.sortOrder
        }
  
        const sortOptions = {
          field: sortColumn,
          order: sortType
        }
        data = {
          ...data,
          ...sortOptions
        }
  
        this.loading = true
        const pageSize = query ? query.pageSize : 20
        const page = query ? query.page : 1
        this.apiRequest('/reports/client-points?page=' + page + '&pageSize=' + pageSize, 'GET', data, response => {
          if (response.status === true) {
            this.donation_points_enabled = response.data.use_donation_points
            this.clientsTableData = response.data.clients.data
            this.totalClients = response.data.clients.total
            this.labels = response.data.labels
            this.labelingPrimaryOption = response.data.fidelities_labels_primary_option
  
            // this.$refs.refClientsChart.initChart()
            // this.clientsExportData = []
            if (this.clientsTableData) {
              for (const customer of this.clientsTableData) {
                // $dd = {
                //   'firstname': customer.firstname,
                //   'email': customer.email,
                //   'phone': customer.phone,
                //   'gender': customer.gender,
                //   'birthdate': customer.birthdate,
                //   'age': customer.age,
                //   'orders_count': customer.orders_count,
                //   'sales': this.formatMoneyAmount(customer.sales, '')
                // }
                // if (customer.donation_points) {
                //   $dd['donation_points'] = customer.donation_points
                // }
                // this.clientsExportData.push($dd)
                if (customer.lastname) {
                  customer['firstname'] = customer.firstname + ' ' + customer.lastname
                }
              }
            }
          }
          this.$nextTick(function () {
            this.loading = false
          })
        })
      },
      goToRecordCustomer (row, event, column) {
        window.open(`/#/reports/customer/${row.id}`)
      }
    }
  }
  </script>
  


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Reports/ClientPoints.vue